// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2Bs8I","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__28f9S"};